<template>
  <component :is="tag"
             class="s-heading"
             :class="className"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'SHeading',
  props: {
    variant: {
      type: String,
      default: 'primary',
      validator: function (value) {
        return ['primary', 'secondary'].includes(value)
      },
    },

    size: {
      type: String,
      default: 'm',
      validator: function (value) {
        return ['xl', 'l', 'm', 's'].includes(value)
      },
    },

    align: {
      type: String,
      default: 'left',
      validator: function (value) {
        return ['left', 'center', 'right'].includes(value)
      },
    },
  },

  computed: {
    className() {
      return [`s-heading--${this.align}`, `s-heading--${this.size}`]
    },

    tag() {
      switch (this.size) {
      case 'xl':
        return 'h1'
      case 'l':
        return 'h2'
      case 'm':
        return 'h3'
      case 's':
        return 'h4'
      default:
        return 'h4'
      }
    },
  },
}
</script>

<style scoped lang="scss">
.s-heading {
  margin: 0;
  padding: 0;

  &--xl {
    color: $color-gray-400;
    font-size: pxtorem(28);
    font-weight: $font-weight-normal;
    line-height: pxtorem(32);
    letter-spacing: -0.75px;
  }

  &--l {
    color: $color-gray-400;
    font-size: pxtorem(25);
    font-weight: $font-weight-normal;
    line-height: pxtorem(28);
    letter-spacing: -0.5px;
  }

  &--m {
    color: $color-gray-400;
    font-size: pxtorem(20);
    font-weight: $font-weight-normal;
    line-height: pxtorem(24);
    letter-spacing: -0.25px;
  }

  &--s {
    color: $color-gray-400;
    font-size: pxtorem(17);
    font-weight: $font-weight-normal;
    line-height: pxtorem(20);
    letter-spacing: -0.2px;
  }

  &--left {
    text-align: left;
  }

  &--center {
    text-align: center;
  }

  &--right {
    text-align: right;
  }
}
</style>
